import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcFirewall = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M1.762 4.75a1.5 1.5 0 0 1 1.5-1.5h2.5v4h-4v-2.5Zm0 3.5h8.5v4h-8.5v-4Zm0 5h4v4h-2.5a1.5 1.5 0 0 1-1.5-1.5v-2.5Zm5-10h8v4h-8v-4Zm6.185 14a5.14 5.14 0 0 1-.083-.66l-.001-.025-.078-2.923a2.512 2.512 0 0 1 .02-.392H6.762v4h6.185Zm6.815-6.495-.763-.143a3.998 3.998 0 0 0-1.474 0l-2.702.506a2.497 2.497 0 0 0-1.659 1.132h-1.902v-4h8.5v2.505Zm-4-7.505h2.5a1.5 1.5 0 0 1 1.5 1.5v2.5h-4v-4Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M14.284 13.603a1 1 0 0 1 .815-1.01l2.701-.506a2.5 2.5 0 0 1 .922 0l2.7.506a1 1 0 0 1 .816 1.01l-.077 2.897c-.15 2.5-2.9 4.25-3.9 4.25s-3.75-1.75-3.9-4.25l-.077-2.897Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcFirewall");

export { IcFirewall };
//# sourceMappingURL=ic-firewall.js.map
